module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Elodie-meisje-letterpress-roze-1.8c3b13a7.jpg";